<template>
  <div>
    <div class="row">
      <div class="form-group col-md-4">
        <label for="description" class="mb-1"><b><u class="section-title"><i class="fab fa-elementor"></i>&nbsp;&nbsp;Activity Logs&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u></b></label>
        <input v-model="filter.description" type="text" class="form-control input_sm" name="description" placeholder="Descripción" @keyup.enter="getRecords(null)">
      </div>
      <div class="form-group col-md-4">
        <label for="log_name" class="mb-1"><b>Log</b></label>
        <v-select v-model="filterLogName" :options="logNames" class="my-custom-select" placeholder="Todos"></v-select>
      </div>
      <div class="form-group col-md-4">
        <label for="causer" class="mb-1"><b>Usuario</b></label>
        <v-select v-model="filterCauser" :options="causers" class="my-custom-select" placeholder="Todos"></v-select>
      </div>
      <div class="form-group col-md-3">
        <label for="date_from" class="mb-1"><b>Desde</b></label>
        <date-field v-model="filter.date_from" id="date_from" name="date_from"></date-field>
      </div>
      <div class="form-group col-md-3">
        <label for="date_to" class="mb-1"><b>Hasta</b></label>
        <date-field v-model="filter.date_to" id="date_to" name="date_to"></date-field>
      </div>
      <div class="col-md-12">
        <button class="btn btn-sm btn-success btn-icon-split" title="Filtrar o buscar registro" @click="getRecords(null)"><i class="fas fa-filter"></i> Filtrar</button>
        <button class="btn btn-sm btn-danger btn-icon-split" title="Borrar filtro" @click="clearFilter()"><i class="fas fa-ban"></i></button>
        <hr>
      </div>
    </div>

    <b-overlay :show="loading" rounded="sm">
      <div class="table-responsive tableBg">
        <table class="table table-striped table-bordered zero-configuration">
          <thead>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Fecha</th>
              <th>Log</th>
              <th>Descripción</th>
              <th>Usuario</th>
              <th>Registro</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(record, index) in records" :key="index">
              <td>{{ record.index }}</td>
              <td>
                <button class="btn btn-sm btn-success btn-icon-split btn-xs" @click="showRecord(record)" title="Ver">
                  <span class="icon text-white">
                    <i class="fas fa-eye icon_white"></i>
                  </span>
                </button>
              </td>
              <td>{{ record.date }}</td>
              <td>{{ record.lognamelbl }}</td>
              <td>{{ record.description }}</td>
              <td>{{ record.causername }}</td>
              <td>{{ record.subjectname }}</td>
            </tr>
            <tr v-if="total == 0">
              <td colspan="7">No hay registros</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>#</th>
              <th>Acciones</th>
              <th>Fecha</th>
              <th>Log</th>
              <th>Descripción</th>
              <th>Usuario</th>
              <th>Registro</th>
            </tr>
          </tfoot>
        </table>
      </div>
      <!-- Contenedor de paginación -->
      <div class="pagination-container d-flex justify-content-end">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" v-for="link in links" :class="{'disabled': link.url == null, 'active': link.active}">
              <a class="page-link" @click="getRecords(link.url)" v-html="link.label"></a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="text-right">
        <span><i style="font-size: 14px; color: #7A7A7A">Cantidad de registros: {{total}}</i></span>
        <hr>
        <br>
      </div>
    </b-overlay>
    <modal-record v-if="recordId" :record="dataRecord" :showModal.sync="showModalRecord"></modal-record>
  </div>
</template>

<script>
import ModalRecord from './partials/ModalRecord.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { BOverlay } from 'bootstrap-vue'

export default {
  components: {BOverlay, ModalRecord, vSelect},
  data() {
    return {
      records: [],
      loading: false,
      // Las claves se declaran para que Vue 2 las haga reactivas: date-field es
      // un componente controlado y no reflejaría la selección si no lo fueran.
      filter: this.emptyFilter(),
      filterLogName: null,
      filterCauser: null,
      logNames: [],
      causers: [],
      links: {},
      total: 0,
      recordId: null,
      dataRecord: [],
      showModalRecord: false
    }
  },
  created() {
    this.getLogNames()
    this.getCausers()
    this.getRecords(null)
  },
  methods:{
    emptyFilter() {
      return {
        description: '',
        date_from: '',
        date_to: '',
      }
    },
    getLogNames() {
      axios.get('/configuration/activityLogs/getLogNames')
        .then(response => {
          this.logNames = response.data.data
        })
        .catch(error => {
          console.error(error)
        })
    },
    getCausers() {
      axios.get('/configuration/activityLogs/getCausers')
        .then(response => {
          this.causers = response.data.data
        })
        .catch(error => {
          console.error(error)
        })
    },
    clearFilter(){
      this.filter = this.emptyFilter();
      this.filterLogName = null;
      this.filterCauser = null;
      this.getRecords(null)
    },
    getRecords(url = null) {
      this.loading = true
      let page = 1
      if(url) {
        let param = new URL(url);
        page = param.searchParams.get("page");
      }
      const params = Object.assign({}, this.filter, {
        log_name: this.filterLogName ? this.filterLogName.value : null,
        causer_id: this.filterCauser ? this.filterCauser.value : null
      })
      axios.get(`/configuration/activityLogs/records?page=${page}`, {params: params})
        .then(response => {
          this.records = response.data.data.data
          this.links = response.data.data.links
          this.total = response.data.data.total
        })
        .catch((error)=>{
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    showRecord(record) {
      this.recordId = record.id
      this.dataRecord = record
      this.showModalRecord = true
    },
  }
}
</script>

<style scoped>
.pagination-container {
  margin-top: 10px !important; /* Ajusta según sea necesario */
}
</style>
